import React from 'react';

import gridWidth from '../shared/grid-width';

import {
  PrismicSliceVideoText,
  PrismicSliceTextVideo,
} from '../../../../../types';

import * as S from './styles';

type Props = {
  data: PrismicSliceVideoText | PrismicSliceTextVideo;
  reverse?: boolean;
};

const VideoText = ({ data, reverse }: Props) => {
  const width = gridWidth(data.gridLayout);

  return (
    <S.VideoText>
      <S.Text data={data.text} width={width} reverse={!!reverse} />
      <S.Video data={data.video} width={width} reverse={!!reverse} />
    </S.VideoText>
  );
};

export default VideoText;
